import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const from = location.state?.from || "/";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : from);
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12 bg-[#f6f3ee]">
      <div className="w-full max-w-md bg-white border border-neutral-200 rounded-sm p-8">
        <div className="text-center mb-6">
          <img src="/logo.png" alt="Deegford" className="h-16 w-auto object-contain mx-auto mb-4" />
          <h1 className="font-serif text-3xl text-neutral-900">Welcome Back</h1>
          <p className="text-sm text-neutral-500 mt-2">Sign in to your Deegford account</p>
        </div>
        <form onSubmit={submit} className="mt-4 space-y-4">
          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-1.5">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-neutral-300 rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:border-[#C8932F]" />
          </div>
          <div>
            <label className="block text-sm font-medium text-neutral-700 mb-1.5">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-neutral-300 rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:border-[#C8932F]" />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button type="submit" disabled={loading}
            className="w-full bg-gradient-to-br from-[#FFE29A] to-[#C8932F] text-[#050304] py-3 text-sm font-semibold uppercase tracking-widest rounded-sm hover:opacity-90 transition-opacity flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Signing in...</> : "Sign In"}
          </button>
        </form>
        <p className="text-center text-sm text-neutral-600 mt-6">
          New to Deegford? <Link to="/register" className="text-[#C8932F] font-medium hover:underline">Create account</Link>
        </p>
        <p className="text-center text-xs text-neutral-400 mt-4">Admin demo: admin@deegford.com / Admin@123</p>
      </div>
    </div>
  );
};

export default Login;
